export default __webpack_public_path__ + "static/media/gifsite1-en.700100c7.m4v";